import Text from 'common-components/Text'
import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const UploadMusicLoadingWrapper = styled.div`
  width: 100%;
  height: 48px;
  min-height: 48px;
  border: 1px solid ${COLORS.borderColor};
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  margin-bottom: 8px;
`

export const UploadSoundLoadingText = styled(Text)`
  line-height: 15;
  width: 114px;
`

export const DotsLoadingWrapper = styled.div`
  & > div {
    width: 100%;
    padding: 0;
    margin-left: 12px;
  }
`
